var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "vue_svg__arco-icon",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#41b883"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .825l6 10.35 6-10.35H9.6L6 7.035 2.37.825H0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37.825L6 7.065 9.6.825H7.38L6 3.225 4.59.825H2.37z",
    fill: "#35495E"
  })));
}
export default SvgVue;